module.exports = __webpack_public_path__ + "img/5.e57d89a4.jpg";